import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-156" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-157" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-serif text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-158" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-159" data-mp="tyv4n93ba9wo">🏆 </span>Oferta Especial de Lanzamiento
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-red-600 bg-white px-7 pb-8 pt-11 shadow-xl" data-id="element-160" data-mp="u0odmv1ed67u">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-red-600 px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-161" data-mp="13x17bswxzk2l">
            INGLÉS LISTO™
          </span>

          <dl data-id="element-162" data-mp="2fb4y6q88gs3f">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-stone-200 py-4 text-sm" data-id="element-163" data-mp="2fe0xoizqbotz">
                <dt className="text-stone-700" data-id="element-164" data-mp="pjz2nspjxdxq">{row.label}</dt>
                <dd className="shrink-0 text-right font-bold text-red-600" data-id="element-165" data-mp="uiipdvbyytr5">
                  {row.value}
                </dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-stone-200 py-4 text-sm" data-id="element-166" data-mp="zgk4y6a6saxv">
              <dt className="font-bold uppercase tracking-wide text-stone-900" data-id="element-167" data-mp="6tpr3s7vk9td">
                Valor del Sistema:
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-168" data-mp="bs0wnqr4zy5s">US$97</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-red-600" data-id="element-169" data-mp="ftcq67d4t3j9">
            Hoy
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-stone-200 pb-7 pt-2" data-id="element-170" data-mp="kmyw7gosi963">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-171" data-mp="3k6t3a4g6ut6p">
              🏆
            </span>
            <span className="flex items-start font-serif font-black leading-none text-red-600" data-id="element-172" data-mp="vfqxg36xhesq">
              <span className="mt-1 text-2xl" data-id="element-173" data-mp="qgnquebav0in">US$</span>
              <span className="text-6xl" data-id="element-174" data-mp="qfup5rr7717d">16,99</span>
            </span>
            <span className="self-end pb-2 text-sm font-bold text-red-600" data-id="element-175" data-mp="155tnbuir6cmu">
              USD
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-stone-600" data-id="element-176" data-mp="107s85kog6xgn">
            <span aria-hidden="true" data-id="element-177" data-mp="cho4xef68zq6">💳 </span>El pago se procesará en tu moneda
            local o en el equivalente a US$16,99.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-178" data-mp="lhkv5kh7m6nc" />

          <p className="mt-4 text-center text-[11px] font-medium text-stone-500" data-id="element-179" data-mp="liche4ox2s0y">
            Descarga Instantánea · Pago Único · Acceso de por Vida · Garantía de
            7 Días
          </p>
        </div>
      </div>
    </section>;
}